import React, { useEffect, useState } from 'react';
import api from '../utils/api';
import { HelpTooltip, HELP } from '../components/HelpTooltip';

const DOT = { green: 'bg-green-400', yellow: 'bg-yellow-400', red: 'bg-red-400' };

export default function Scoreboard() {
  const [data, setData] = useState(null);

  useEffect(() => {
    api.get('/guided/scoreboard').then(({ data }) => setData(data)).catch(() => {});
  }, []);

  if (!data) return null;
  const t = data.totals;

  return (
    <div data-testid="scoreboard">
      <h2 className="text-2xl font-bold text-white mb-1">Your Scoreboard</h2>
      <p className="text-sm text-gray mb-5">Where your numbers land. Plain and simple.</p>

      <div className="grid grid-cols-3 md:grid-cols-5 gap-3 mb-6">
        <div className="rounded-xl border border-divider bg-card-bg p-4 text-center min-w-0" data-testid="scoreboard-leads">
          <p className="text-2xl sm:text-3xl font-black text-lime truncate">{t.leads || 0}</p>
          <p className="text-xs text-gray mt-1 flex items-center justify-center gap-1">Leads <HelpTooltip size={13} text={HELP.leads} testId="help-scoreboard-leads" /></p>
        </div>
        <div className="rounded-xl border border-divider bg-card-bg p-4 text-center min-w-0" data-testid="scoreboard-jobs-booked">
          <p className="text-2xl sm:text-3xl font-black text-[#3b9eff] truncate">{t.jobs_booked ?? 0}</p>
          <p className="text-xs text-gray mt-1">Jobs booked</p>
        </div>
        <div className="rounded-xl border border-divider bg-card-bg p-4 text-center min-w-0" data-testid="scoreboard-revenue">
          <p className="text-2xl sm:text-3xl font-black text-[#ec6a1c] truncate">${Math.round(t.revenue ?? 0).toLocaleString()}</p>
          <p className="text-xs text-gray mt-1 flex items-center justify-center gap-1">Revenue <HelpTooltip size={13} text={HELP.revenue} testId="help-scoreboard-revenue" /></p>
        </div>
        <div className="rounded-xl border border-divider bg-card-bg p-4 text-center min-w-0" data-testid="scoreboard-cpl">
          <p className="text-2xl sm:text-3xl font-black text-white truncate">{t.cost_per_lead != null ? `$${t.cost_per_lead}` : '—'}</p>
          <p className="text-xs text-gray mt-1 flex items-center justify-center gap-1">Cost per lead <HelpTooltip size={13} text={HELP.cpl} testId="help-scoreboard-cpl" /></p>
        </div>
        <div className="rounded-xl border border-divider bg-card-bg p-4 text-center min-w-0" data-testid="scoreboard-spend">
          <p className="text-2xl sm:text-3xl font-black text-white truncate">${Math.round(t.spent_this_week || 0).toLocaleString()}</p>
          <p className="text-xs text-gray mt-1 flex items-center justify-center gap-1">Spent this week <HelpTooltip size={13} text={HELP.spend} testId="help-scoreboard-spend" /></p>
        </div>
      </div>

      {data.campaigns.length > 0 ? (
        <div className="space-y-3">
          {data.campaigns.map((c) => (
            <div key={c.campaign_id} className="rounded-xl border border-divider bg-card-bg p-4 flex items-center gap-3" data-testid={`scoreboard-campaign-${c.campaign_id}`}>
              <span className={`w-3 h-3 rounded-full shrink-0 ${DOT[c.status]}`} />
              <div className="flex-1 min-w-0">
                <p className="text-white font-bold truncate">{c.name}</p>
                <p className="text-xs text-gray">{c.leads} leads · ${c.spend} spent{c.cost_per_lead != null ? ` · $${c.cost_per_lead}/lead` : ''}</p>
              </div>
              <p className="text-lime font-bold shrink-0 flex items-center gap-1">${c.revenue} <HelpTooltip size={13} text={HELP.revenue} testId={`help-revenue-${c.campaign_id}`} /></p>
            </div>
          ))}
        </div>
      ) : (
        <p className="text-sm text-gray" data-testid="scoreboard-empty">No campaign numbers yet — launch your first campaign and they'll show up here.</p>
      )}
    </div>
  );
}
